var _circle, _rect, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainToMain = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 12,
    viewBox: "0 0 75 12",
    fill: "#BCBEC0",
    stroke: "#BCBEC0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 60,
    height: 2,
    fill: "#BCBEC0",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 6,
    r: 5.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainToMain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MainToMain.f58a195ae80a0d896ccd30ec7af7118b.svg";